

import { string } from '@amcharts/amcharts4/core';
import { CommonService } from './../../../shared/services/common.service';
import { Component, OnInit, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { ResellerInfoModel } from '../../../account/models/profile/reellerInfoModel';
import { OrderInfoModel } from '../../models/orderInfoModel';
import { BankTranactionModel } from '../../models/bankTranactionModel';
import { OrderInfoItems } from '../../models/orderInfoItems';
import { Subject, Subscription } from 'rxjs';
import { PurchaseService } from '../../services/purchase.service';
import { MatDialog, MatStepper, MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../account/services/account.service';
import { PurchaseProductModel } from '../../models/purchaseProductModel';
import { PurchaseOrderModel } from '../../models/purchaseOrderModel';
import { ClipboardService } from 'ngx-clipboard';
import { ContactInfoModel } from '../../../shared/models/contactInfoModel';
import { SharedObject } from '../../../shared/sharedObject';
import { ProductInfoModel } from '../../models/productInfoModel';
import { DiscountModel } from '../../models/discountModel';
import { EnumTableModel } from '../../../admin/models/enumTableModel';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-purchase',
  templateUrl: './new-purchase2.component.html',
  styleUrls: ['./new-purchase2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewPurchase2Component implements OnInit {

  //موقع ساخت سفارش
  loading = true;
  showMessage = null;
  referralSources: EnumTableModel[] = [];
  selectedReferralSource: string = 'null';
  //اطلاعات کاربر
  sellerInfo: ResellerInfoModel = new ResellerInfoModel();
  purchaseFormGroup: FormGroup;
  //ذخیره اطلاعات کاربر لاگین شده شامل شماره تماس
  contactInfoModel: ContactInfoModel = new ContactInfoModel();
  //شماره سفارش
  orderId: string = null;
  //نمایش خطای هنگام ثبت سفارش در مرحله یک
  //مربوط به ارسال به سمت بانک
  bankorderId: string;
  bankTransactionId: string;
  activationCode: string;
  year: string;
  deviceCount: string;
  tags: string;
  purchasedProductId: number;
  bankTranactionModel: BankTranactionModel = new BankTranactionModel();
  MobileValidationshowMessage: string = null;
  currentOrder: OrderInfoModel = new OrderInfoModel();
  currentOrderItem: OrderInfoItems = new OrderInfoItems();
  productInfoId: number = 0;
  prodcutInfo: ProductInfoModel = null;
  discountCode: string = null;
  discount: DiscountModel = new DiscountModel();
  getWay: number = null;
  getWayName: string;
  paymentErrorMessage: string = null;
  discountClicked: boolean = false;
  complateActionLabel: string = "دریافت کد فعالسازی";
  hasDiscount: boolean = false;
  finalPageTitle = 'تبریک!';
  step: number = 0;
  isextContent: string = 'خرید';
  constructor(
    private _formBuilder: FormBuilder,
    private purchaseService: PurchaseService,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private router: Router,
    private clipboardService: ClipboardService,
    private commonService: CommonService,

  ) {

    this.discountCodeSubject
      .pipe(debounceTime(500)) // Wait for 500ms
      .subscribe((code) => {
        this.enterDiscountCode(code);
      });
  }

  ngOnInit() {
    this.initializePurchasePostForm();

    // دریافت پارامترهای query از URL
    this.getQueryParams();

    // دریافت منابع ارجاعی
    this.purchaseService.getReferralSource().subscribe((res: EnumTableModel[]) => {
      this.referralSources = res;
    });

    // دریافت پارامترهای خاص
    this.route.queryParams.subscribe(params => {
      if (params['isext']) {
        this.isextContent = 'تمدید';
      }
    });

  //  this.checkProuduct();
  }

  private getQueryParams(): void {
    const params = this.route.snapshot.queryParamMap;
    const queryParams = {
      bankorderId: params.get('bankorderId'),
      bankTransactionId: params.get('bankTransactionId'),
      activationCode: params.get('activationCode'),
      year: params.get('year'),
      deviceCount: params.get('deviceCount'),
      productId: params.get('productId'),
      discountCode: params.get('discountCode'),
      priceId: params.get('priceId'),
      tags: params.get('t'),
      msg: params.get('msg'),
    };


    this.bankorderId = queryParams.bankorderId;
    this.bankTransactionId = queryParams.bankTransactionId;
    this.activationCode = queryParams.activationCode;
    this.year = queryParams.year;
    this.deviceCount = queryParams.deviceCount;
    this.purchasedProductId = +queryParams.productId;
    this.productInfoId = +queryParams.priceId;
    this.discountCode = queryParams.discountCode;
    this.tags=queryParams.tags;
    const controls = this.purchaseFormGroup.controls;
    controls['discountCodeControl'].setValue(this.discountCode);

    if (queryParams.bankorderId && queryParams.bankTransactionId && queryParams.activationCode && queryParams.year && queryParams.deviceCount && queryParams.productId) {
      this.step = 1;
    } else if (queryParams.msg) {
      this.processErrorMessage(queryParams);
    }else{
      this.checkProuduct();
    }
  }

  private processErrorMessage(queryParams: any): void {
    this.finalPageTitle = 'خطا';
    this.paymentErrorMessage = queryParams.msg;
    this.step = 1;
    this.complateActionLabel = "خرید ناتمام";
  }


  checkProuduct() {
    this.loading = true;
    //هیچ محصولی انتخاب نکرده
    if (this.productInfoId == 0) {
      if (this.discountCode != null)
        this.router.navigateByUrl(`/purchase/purchase/plan?discountCode=${this.discountCode}`);
      else
        this.router.navigate([`/purchase/purchase/plan`]);
    } else {
      this.purchaseService.getProductInfoById(this.productInfoId).subscribe((res: ProductInfoModel) => {
        if (res == null)
          this.router.navigate([`/purchase/purchase/plan`]);
        this.prodcutInfo = res;
        this.loadContractInfo();
        this.enterDiscountCode(this.discountCode);

        this.loading = false;
        this.changeDetectorRef.markForCheck();
      }, (err) => {
        this.router.navigate([`/purchase/purchase/plan`]);
      })
    }
    this.changeDetectorRef.markForCheck();
  }


  loadContractInfo() {
    this.commonService.getContactInfo().subscribe((res: ContactInfoModel) => {
      this.contactInfoModel = res;
      this.changeDetectorRef.markForCheck();
    });
  }

  initializePurchasePostForm() {
    this.purchaseFormGroup = this._formBuilder.group({
      selectedProductType: ['', Validators.compose([
        Validators.required
      ])
      ],
      mobileNumber: ['', Validators.compose([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(11),
        Validators.pattern(SharedObject.MobilePattern)
      ]),
      ],
      discountCodeControl: ['', Validators.compose([])]
    });
  }


  optimizePhoneNumber(value: string): string {
    if (!value) return value;
    value = value.replace(/\s+/g, '');
    if (value)
      value = this.faToEnDigits(value);
    return value;
  }

  faToEnDigits(text: string): string {
    return text.replace('۰', '0')
      .replace('۱', '1')
      .replace('۲', '2')
      .replace('۳', '3')
      .replace('۴', '4')
      .replace('۵', '5')
      .replace('۶', '6')
      .replace('۷', '7')
      .replace('۸', '8')
      .replace('۹', '9');
  }


  validationPhonenumber(value: string): boolean {
    value = this.optimizePhoneNumber(value);
    if (!value) return false;
    return Boolean(value.match(SharedObject.MobilePattern));
  }

  //////////////////////////////////////////////////////////////////////////////////////////********************************* */
  enterDiscountCode(code: string) {
    if (code != null && code.length > 0)
      this.discountClicked = true;
    this.discount = new DiscountModel();
    if (code == null || code.length == 0) {
      this.discount.isValid = false; //نمایش خطای نامعتبر بودن
      this.changeDetectorRef.markForCheck();
      return;
    }
    this.loading = true;
    this.purchaseService.getDiscountByCode(code).subscribe((res: DiscountModel) => {

      if (res) {
        if (res.productId != null && res.productId != this.prodcutInfo.sheedProductId) {

          this.discount.error = 'کد تخفیف برای این محصول نیست';
          this.discount.isValid = false;
          this.discount.serial = '';
          this.discount.percent = 0;
          this.loading = false;
          this.changeDetectorRef.markForCheck();
          return;

        }


        this.discount = res;
        this.discount.isValid = true;
        this.discount.serial = res.serial;
        this.discount.percent = res.percent;
        this.loading = false;
        this.changeDetectorRef.markForCheck();

      } else {
        this.discount.isValid = false;
        this.discount.serial = '';
        this.discount.percent = 0;
        this.loading = false;
        this.changeDetectorRef.markForCheck();
        return;
      }

    }, (err) => {
      this.loading = false;//نمایش اسپینر
    });

  }

  async createOrder(mobile: string) {
    if (!this.validationPhonenumber(mobile)) return;
    var model = new PurchaseOrderModel();
    model.customerContact = mobile.trim();
    model.priceId = this.prodcutInfo.id;
    model.productId = this.prodcutInfo.sheedProductId;
    model.orderCount = 1;
    model.DiscountCode = this.discount.serial;
    model.IsRenewal = false;
    model.tags=this.tags;
    this.loading = true;
    await this.purchaseService.createPurchaseOrder(model).toPromise().then((res: number) => {
      if (res <= 0) {
        this.loading = false;
        return;
      }
      this.orderId = res['orderId'];
      this.loading = false;
      this.changeDetectorRef.markForCheck();
    }, (err) => {
      this.loading = false;

      this.showMessage = err.error['result'];
      this.changeDetectorRef.markForCheck();
      return;
    });
    await this.purchaseService.getPurchaseOrder(this.orderId).toPromise().then((res: OrderInfoModel) => {
      this.changeDetectorRef.markForCheck();
      this.currentOrder = res;
      this.currentOrderItem = this.currentOrder.orderItems[0];

      this.getWay = this.currentOrderItem.defaultGateway;
      this.getWayName = this.getBankName(this.getWay);
      this.changeDetectorRef.markForCheck();
    });

  }

  changeGetWay(value: number) {
    this.getWay = value;
    this.getWayName = this.getBankName(this.getWay);
    this.changeDetectorRef.markForCheck();
  }

  bankPaymentClick() {

    this.showMessage = null;
    this.MobileValidationshowMessage = null;
    const controls = this.purchaseFormGroup.controls;
    // check form
    if (controls['mobileNumber'].errors != null && !controls['mobileNumber'].value) {
      this.MobileValidationshowMessage = "لطفا یک شماره موبایل معتبر وارد کنید";
      return;
    }

    if (!this.commonService.isValidRegex(SharedObject.MobilePattern, controls['mobileNumber'].value)) {
      this.MobileValidationshowMessage = "لطفا یک شماره موبایل معتبر وارد کنید";
      return;
    }
    var model = new PurchaseOrderModel();
    model.customerContact = controls['mobileNumber'].value;
    model.priceId = this.prodcutInfo.id;
    model.productId = this.prodcutInfo.sheedProductId;
    model.orderCount = 1;
    if (this.discount.isValid)
      model.DiscountCode = this.discount.serial;
    model.IsRenewal = false;
    if (this.selectedReferralSource == null || this.selectedReferralSource == 'null')
      model.referralSource = null;
    else
      model.referralSource = this.selectedReferralSource;


    this.loading = true;
    model.tags=this.tags;
    this.purchaseService.createPurchaseOrder(model).toPromise().then((res: number) => {
      if (res <= 0) {
        this.loading = false;
        return;
      }
      this.orderId = res['orderId'];
      this.changeDetectorRef.markForCheck();
    }, (err) => {
      this.loading = false;
      this.showMessage = err.error['result'];
      this.changeDetectorRef.markForCheck();
      return;
    })
      .then(() => {
        this.purchaseService.getPurchaseOrder(this.orderId).toPromise().then((res: OrderInfoModel) => {
          this.changeDetectorRef.markForCheck();
          this.currentOrder = res;
          this.currentOrderItem = this.currentOrder.orderItems[0];
          this.getWay = this.currentOrderItem.defaultGateway;
          this.getWayName = this.getBankName(this.getWay);
          this.changeDetectorRef.markForCheck();
        }).then(() => {
          if (!this.getWay || this.getWay == null) {
            this.loading = false;
            this.showMessage = "لطفا درگاه پرداخت را انتخاب نمائید";
            return;
          }
          this.showMessage = null;
          this.purchaseService.doBankPayment(this.currentOrder.orderId, this.getBankNameId(this.getWay))
            .subscribe((res: BankTranactionModel) => {
              this.bankTranactionModel = res;
              this.changeDetectorRef.markForCheck();
              this.postRefId(res.refId, res.sendToBankUrl, res.sendMethod)
            }, err => {
              this.loading = false;
              this.showMessage = err.error['result'];
              this.changeDetectorRef.markForCheck();
            });

        });
      });
  }



  copyCode(code: string) {
    if (code == null) return;

    this.clipboardService.copyFromContent(code);
    this.snackBar.open("با موفقیت کپی شد", null, {
      duration: 2000,
    });
  }
  postRefId(refIdValue: string, bankUrl: string, sendMethod: string) {
    try {
      if (sendMethod.toLowerCase() === 'get') {
        window.location.href = bankUrl;
        return false;
      } else {

        var form = document.createElement("form");
        form.setAttribute("method", sendMethod);
        form.setAttribute("action", bankUrl);
        form.setAttribute("target", "_self");
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("name", "RefId");
        hiddenField.setAttribute("value", refIdValue);
        form.appendChild(hiddenField);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }

    } catch {
      this.showMessage = "خطا در ارسال به بانک پذیرنده";
      this.changeDetectorRef.markForCheck();
    }

  }
  getBankName(id: number): string {
    if (id == 1) return "پارسیان";
    if (id == 2) return "ملت";

    if (id == 3) return "زرین پال";
    if (id == 4) return "زرین پال";
  }

  getBankNameId(id: number): string {
    if (id == 1) return "parsian";
    if (id == 2) return "melat";

    if (id == 3) return "zarinpal1";
    if (id == 4) return "zarinpal2";
  }




  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.purchaseFormGroup.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  getValuePerPercent(percent: number) {
    if (this.prodcutInfo == null) return 0;
    if (this.prodcutInfo.price <= 0) return 0;
    return this.prodcutInfo.price * percent / 100;
  }

  removeDiscountCode() {
    this.discountClicked = false;
    this.discount.isValid = false;
    this.discount.serial = '';
    this.discount.percent = 0;
    this.loading = false;
    this.changeDetectorRef.markForCheck();

  }

  helpButtonClick() {

    document.location.href = "http://sheed.to/avactivationhelp";
  }

  back() {
    this.router.navigate(['/purchase/purchase/plan']);
  }

  private discountCodeSubject = new Subject<string>();

  enteringDiscountCode(code: string) {
    if (code.length < 3) return;
    this.discountCodeSubject.next(code); // Emit the code
    // this.enterDiscountCode(code);
  }

  referralSourceChanged(value) {
    this.selectedReferralSource = value;
  }

  getPrice() {
    return this.prodcutInfo.price / 10;
  }

  getDiscountValue() {
    if (this.prodcutInfo == null) return 0;
    if (this.prodcutInfo.price <= 0) return 0;
    if (!this.discount) return 0;
    if (!this.discount.percent || this.discount.percent <= 0) return 0;
    return ((this.getPrice() * this.discount.percent) / 100);
  }

  getTax() {
    let priceAfterDiscount = this.getPrice() - this.getDiscountValue();
    return (priceAfterDiscount * 10) / 100;
  }

  getFinalPrice() {
    return this.getPrice() - this.getDiscountValue() + this.getTax();
  }
}

